import { Component } from 'react';
import { connect } from 'react-redux';

import classnames from 'classnames';
import classBind from 'classnames/bind';

import styles from './styles.scss';

let cx = classBind.bind(styles);

class TabNavItem extends Component {
  render() {
    const { style, justified, active, onClick } = this.props;

    let className = cx({
      tabNavItem: true,
      [`${style}`]: true,
      active: active,
      justified: justified,
    });

    return (
      <div className={classnames(className)} onClick={onClick}>
        <a href=""> {this.props.children} </a>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    style: state.configuration.style,
  };
};

export default connect(mapStateToProps)(TabNavItem);
